import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { AvatarAPI, FetchAPI, MapperAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import { Inject } from '@odinjs/odin';
import { AuthenticationService, MessageService, JWTToken } from '@philips-internal/oswald-ui-core/lib/services';
import './results-portal-root.css';
import { wrapImageBase64 } from '../../utils/wrapImageBase64';
import { Person } from '../../interfaces/Person';
import TokenConstants from '../../constants/TokenConstants';
import LoginTypeConstants from '../../constants/LoginTypeConstants';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

@Controller({ fragment: 'results-portal-root', component: 'root-layout' })
class ResultsPortalRootController extends BaseController {

  @Inject('fetch-user-profile')
  fechUserProfile: FetchAPI;

  @Inject('avatar-profile-dropdown')
  avatar: AvatarAPI;

  @Inject('mapper-user-profile')
  mapperUserProfile: MapperAPI;

  @Inject('mapper-user-profile-2')
  mapperUserProfile2: MapperAPI;

  @Inject('text-access-type')
  textAccessType: TextAPI;

  @OnClick({ target: 'link-logout' })
  onLogoutLinkClick(): void {
    AuthenticationService.logout();
  }

  @OnMount({ target: ['patients-list-fragment'] })
  onMountExam(): void {
    applicationContext.clearNavigationStack();
    applicationContext.openModule('exam-results');
    applicationContext.closeModule('profile');
  }

  @OnMount({ target: ['users-fragment'] })
  onMountUsers(): void {
    applicationContext.clearNavigationStack();
    applicationContext.openModule('users');
    applicationContext.closeModule('profile');
  }

  @OnMount({ target: ['root-layout', 'layout-dependents'] })
  onApplicationBarMount(): void {
    const token = AuthenticationService.getJWTToken() as JWTToken;
    const cdPhysicalPerson: number = token.claims[TokenConstants.CD_PHYSICAL_PERSON] as number;
    const data = { cdPhysicalPerson };
    this.context.set(data);
    this.updateAvatarByMapper(this.mapperUserProfile, '/static/assets/icons/nophoto.svg');
    this.updateAvatarByMapper(this.mapperUserProfile2, '/static/assets/icons/avatar-user-gray.svg');
    this.textAccessType.setValue(this.getTitleByType());
  }

  @OnClick({ target: 'link-profile' })
  onClickAvatar(): void {
    applicationContext.clearNavigationStack();
    applicationContext.openModule('profile');
  }

  @OnClick({ target: 'card-main-result' })
  onClickCardMainPatient(): void {
    this.fechUserProfile.forceFetch();
  }

  private updateAvatarByMapper(mapperApi: MapperAPI, avatar: string): void {
    mapperApi.addCustomMapping('image', data => {
      const userInformation = data as unknown as Person;
      return wrapImageBase64(userInformation.imPessoaFisica, avatar);
    });
  }

  getTitleByType(): string {
    const token = AuthenticationService.getJWTToken() as JWTToken;
    const ieLoginType: string = token.claims[TokenConstants.IE_LOGIN_TYPE] as string;

    switch (ieLoginType) {
      case LoginTypeConstants.CD_CATEGORY: {
        return MessageService.translate('result.access') + ' ' + MessageService.translate('result.category');
      }
      case LoginTypeConstants.CD_HEALTH_INSURANCE: {
        return MessageService.translate('result.access') + ' ' + MessageService.translate('result.insurance');
      }
      case LoginTypeConstants.CD_ORIGIN: {
        return MessageService.translate('result.access') + ' ' + MessageService.translate('result.prior.location');
      }
      case LoginTypeConstants.CD_PHYSICAL_PERSON: {
        return MessageService.translate('result.access') + ' ' + MessageService.translate('result.physician');
      }
      default: {
        throw 'Internal Server Error';
      }
    }
  }
}

const instance = new ResultsPortalRootController();

export {
  instance as default,
  ResultsPortalRootController,
}
